import React, {useRef, useEffect} from 'react';
import {useCookies} from "react-cookie";
import useWindowDimensions from '../common/WindowResize';
import InfoBanner from './InfoBanner';
import SmartBanner from './SmartBanner';
import withViewport from "../hoc/withViewport";
import styles from "./Banner.module.scss";

const Banners = (props) => {

    const {style, setBannerHeight} = props;

    const ref = useRef(null);
    const {height, width} = useWindowDimensions();
    const [cookies, setCookie] = useCookies(['infoBanner', 'smartBanner']);

    useEffect(() => heightChanged(), [width, cookies]);

    const heightChanged = () => {
        setBannerHeight(ref && ref.current && (ref.current.clientHeight - 1) || 0)
    };

    const handleClose = (name) => {
        setCookie(name, false, { path: '/' });
    };

    return (
        <div className={styles.bannerWrap} ref={ref} style={style}>

            <SmartBanner
                show={!cookies.smartBanner && props.viewport !== 'desktop'}
                handleClose={handleClose}
            />
        </div>
    );
};

export default withViewport(Banners);

{/*
Can be useful in future to display some info Banner -> need only move this block to render line 29
<InfoBanner
    show={!cookies.infoBanner}
    heightChanged={heightChanged}
    handleClose={handleClose}
/>*/}
